import { Brand } from '@adecco/base-app/src/utilities/appProvider/appProvider.types';

export const ITEM_BRANDS: Record<Brand, string> = {
  Adecco: 'ADE DE',
  Dis: 'DIS DE',
  ProServ: 'PRO DE',
  Lhh: 'LHH DE',
} as const;
